import { createTimeline } from "animejs";
import type { ReactNode, Ref } from "react";

/**
 * The plane every bento thumbnail draws into: decorative and out of the tap target,
 * filling the card's graphic area. It sits *in flow* at the bottom of the tile rather
 * than behind the copy, the thumbnail is the card's subject, not its backdrop, so the
 * caller owns only height and inner alignment. Takes the animation ref itself, the way
 * `Layer` does in `4-components/composites/backdrops.tsx`.
 *
 * The dimmed-until-hover skin is part of the plane: every mini rests at 60% and lifts
 * to full opacity with the card hover, so it lives here once.
 */
export function BentoArt({ className, children, ref }: { className: string; children: ReactNode; ref?: Ref<HTMLDivElement> }) {
  return (
    <div
      ref={ref}
      aria-hidden="true"
      className={`pointer-events-none relative w-full opacity-60 transition-opacity duration-500 group-hover:opacity-100 ${className}`}
    >
      {children}
    </div>
  );
}

/**
 * The looping timeline every mini runs on: same pace and default ease across the five
 * tiles, so the grid breathes as one surface. Callers add their own beats.
 */
export const bentoLoop = () => createTimeline({ loop: true, playbackRate: 0.7, defaults: { ease: "inOut(2)" } });
